import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { useAuth } from 'react-oidc-context';
import { LinkContainer } from 'react-router-bootstrap';
import { usePagination } from '../../hooks/usePagination';
import { AddLinkedServerResponse, LinkedServerListDTO, LinkedServerStatus, LinkedServerTenantDTO, TenantLinkStatus } from "../../common/LinkedServer";
import API from '../../common/API';
import { Dropdown } from 'react-bootstrap';


export function LinkedServerListComponent() {
    const auth = useAuth();

    const [servers, pagination, setCustomParams, refresh] = usePagination<LinkedServerListDTO>({ perPage: 10, route: '/api/v1/linkedServer' })

    const [search, setSearch] = React.useState<string>()

    const regenerate = async (server: LinkedServerListDTO) => {
        const response: AddLinkedServerResponse | null = await API.put("/api/v1/LinkedServer/" + server.id + "/Relink", {}, auth);

        if (response == null)
            return;

        refresh();
    }

    const deleteServer = async (server: LinkedServerListDTO) => {

    }

    return (
        <div>
            <div className="d-flex justify-content-between mb-3">
                <h1 className="header-text">
                    <FontAwesomeIcon icon="server" className="fs-3 me-2" />
                    Linked Servers
                </h1>
                <LinkContainer to={"/linkedServers/add"}>
                <button className="btn btn-primary">
                    <FontAwesomeIcon icon="plus" />
                    Add
                </button>
                </LinkContainer>
            </div>

            <div className="row">
                {servers?.map((server: LinkedServerListDTO) => {
                return (
                    <div className="col-12 col-lg-6 col-xl-4 col-xxl-3" key={server.id}>
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <div>
                                    <LinkContainer to={"/linkedServers/" + server.id}><a><h5 className="card-title mb-0">{server.name}</h5></a></LinkContainer>

                                    {server.status === LinkedServerStatus.Online && <div className="badge bg-success">Online</div>}
                                    {server.status === LinkedServerStatus.Offline && <div className="badge bg-danger">Offline</div>}
                                    {server.status === LinkedServerStatus.Expired && <div className="badge bg-warning">Expired</div>}
                                    {server.status === LinkedServerStatus.PendingLink && <div className="badge bg-primary">Pending</div>}
                                </div>

                                <Dropdown>
                                    <Dropdown.Toggle variant="link" className="caret-off" id="serverDropdown">
                                        <FontAwesomeIcon icon="ellipsis-h" />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={(e) => { deleteServer(server)}}>Delete</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                            <div className="card-body p-0">
                                {(server.status === LinkedServerStatus.Online || server.status === LinkedServerStatus.Offline) && renderLinked(server)}
                                {server.status === LinkedServerStatus.PendingLink && renderPending(server)}
                                {server.status === LinkedServerStatus.Expired && renderExpired(server)}

                                {server.tenants.length > 0 && renderTenants(server)}
                            </div>
                        </div>
                    </div>
                )
            })}
            </div>

            <div className="mt-2">{pagination()}</div>
        </div>
    )

    function renderLinked(server: LinkedServerListDTO) {
        return (
            <div className="row mx-0">
                <div className="col-md-6 text-center">
                    <strong>
                        <FontAwesomeIcon icon="tasks" className="me-1" />
                        Software:
                    </strong>&nbsp;
                    {server.softwareType}
                </div>
                <div className="col-md-6 text-center">
                    <strong>
                        <FontAwesomeIcon icon="code-branch" className="me-1" />
                        Version:
                    </strong>&nbsp;{server.softwareVersion}
                </div>
            </div>
        )
    }

    function renderPending(server: LinkedServerListDTO) {
        return (
            <div className="row mx-0 pb-3">
                <div className="col-12 text-center">
                    <div className="form-group row">
                        <label htmlFor="linkKey" className="col-form-label col-sm-3">Link Key</label>
                        <div className="col-sm-9">
                            <div className="input-group">
                                <input type="text" disabled className="form-control" value={server.linkKey} />
                                <button type="button" className="btn btn-primary" onClick={(e) => { navigator.clipboard.writeText(server.linkKey) } }>
                                    <FontAwesomeIcon icon="copy" />
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="pt-2">
                        Expires on {server.linkKeyExpiry != null ? new Date(server.linkKeyExpiry + "Z").toLocaleString() : ""}
                    </div>
                </div>
            </div>
        )
    }

    function renderExpired(server: LinkedServerListDTO) {
        return (
            <div className="row mx-0 pb-3">
                <div className="col-12 text-center">
                    Link Key expired on {server.linkKeyExpiry != null ? new Date(server.linkKeyExpiry).toLocaleString() : ""}

                    <button type="button" className="btn btn-primary w-100" onClick={(e) => { regenerate(server) } }>Regenerate</button>
                </div>
            </div>
        )
    }

    function renderTenants(server: LinkedServerListDTO) {
        return (
            <div className="table-responsive">
                <table className="table table-striped table-sm mb-0">
                    <thead>
                        <tr>
                            <th style={{ width: '1%' }}></th>
                            <th>Deployment</th>
                            <th className="text-center">Account #</th>
                            <th className="text-center">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {server.tenants.map((tenant: LinkedServerTenantDTO) => {
                            return (
                                <tr key={tenant.id}>
                                    {tenant.status === TenantLinkStatus.New && <td>
                                        <LinkContainer to={"/linkedServers/link/" + tenant.id}>
                                            <button className="btn btn-sm btn-primary">
                                                <FontAwesomeIcon icon="plus" />
                                            </button>
                                        </LinkContainer>
                                    </td>}
                                    {tenant.status === TenantLinkStatus.Mapped && <td>
                                        <LinkContainer to={"/deployment/" + tenant.deploymentId}>
                                            <button className="btn btn-sm btn-primary">
                                                <FontAwesomeIcon icon="edit" />
                                            </button>
                                        </LinkContainer>
                                    </td>}
                                    <td>{tenant.name}</td>
                                    <td className="text-center">{tenant.accountNumber}</td>
                                    <td className="text-center">{TenantLinkStatus[tenant.status]}</td>
                                </tr>)
                        })}
                    </tbody>
                </table>
            </div>
        )
    }
}